export const tourSteps = [
  {
    id: 'tools',
    section: 'Tools',
    title: 'Check before you respond',
    body: 'Paste a message or link here to check for warning signs.',
    imageAlt: 'Tools page. The circle highlights where to paste a suspicious message or link.',
    desktopCircle: 'M 128 325 C 12 334, 25 463, 249 476 C 516 499, 1002 482, 1044 424 C 1084 353, 938 310, 625 312 C 385 310, 208 320, 114 338',
    mobileCircle: 'M 72 360 C 14 376, 8 475, 83 495 C 167 520, 349 501, 365 455 C 384 391, 348 356, 242 354 C 159 349, 102 356, 64 371',
  },
  {
    id: 'learn',
    section: 'Learn',
    title: 'Build confidence at your own pace',
    body: 'Start the Fundamentals guide to learn how to spot common scams.',
    imageAlt: 'Learn page. The circle highlights the Start Guide button for Scam Defense Fundamentals.',
    desktopCircle: 'M 95 378 C 46 390, 34 438, 107 454 C 174 468, 309 459, 328 423 C 347 385, 291 368, 196 371 C 146 371, 113 375, 92 389',
    mobileCircle: 'M 68 264 C 18 270, 10 325, 63 342 C 110 357, 222 348, 235 315 C 253 278, 210 258, 146 260 C 108 260, 77 264, 58 279',
  },
  {
    id: 'help',
    section: 'Support',
    title: 'Know what to do next',
    body: 'Choose your situation for clear guidance when something feels wrong.',
    imageAlt: 'Support page. The circle highlights guidance for a suspicious email, text, or call.',
    desktopCircle: 'M 117 288 C 32 291, 15 390, 104 426 C 225 467, 507 444, 562 387 C 615 315, 517 276, 339 280 C 232 280, 158 286, 111 307',
    mobileCircle: 'M 83 318 C 9 330, 6 458, 77 494 C 144 525, 331 510, 362 457 C 395 394, 355 311, 246 311 C 170 308, 115 314, 77 331',
  },
] as const
